<template>
  <div class="fomo-stats-page">
    <div class="row page-heading">
      <h2 class="title">
        Fomo stats
      </h2>
      <div class="row">
        <router-link :to="{ name: 'GeneralStats' }" class="page-link q-mr-md">
          <q-btn flat class="btn-navigation" :class="isUnderlined('general')">
            General stats
          </q-btn>
        </router-link>
        <router-link :to="{ name: 'UserStats' }" class="page-link q-mr-md">
          <q-btn flat class="btn-navigation" :class="isUnderlined('user')">
            User stats
          </q-btn>
        </router-link>
        <router-link :to="{ name: 'PortalStats' }" class="page-link q-mr-md">
          <q-btn flat class="btn-navigation" :class="isUnderlined('portal')">
            Portal stats
          </q-btn>
        </router-link>
        <router-link :to="{ name: 'ConsumptionStats' }" class="page-link">
          <q-btn
            flat
            class="btn-navigation"
            :class="isUnderlined('consumption')"
          >
            Consumption stats
          </q-btn>
        </router-link>

        <router-link :to="{ name: 'FomoStats' }" class="page-link">
          <q-btn flat class="btn-navigation" :class="isUnderlined('fomo')">
            Fomo stats
          </q-btn>
        </router-link>
      </div>
    </div>

    <div class="row">
      <div class="column statfilters-area">
        <div class="search-button">
          <div>
            <p style="font-size: 16px; margin-top: 12px">
              Filters
            </p>
          </div>
          <div class="row justify-end">
            <q-btn
              class="orange-btn bold-font"
              flat
              label="Search"
              @click="searchByTerm()"
              no-caps
            />
          </div>
        </div>

        <div class="stats-filters">
          <div class="filter-box top-margin">
            <q-input
              class="filter-select"
              borderless
              v-model="searchTerm"
              label="Username"
              clearable
              bg-color="white"
            />
          </div>
        </div>
      </div>
      <q-table
        class="sticky-header"
        table-header-style="background-color: #0a1f8f"
        table-header-class="text-white"
        title="FOMO user stats"
        :rows="tableData"
        :columns="columns"
        row-key="id"
        :pagination="pagination"
        style="width: 55vw; margin-left: 12vw; margin-bottom: 36px"
        hide-pagination
        :separator="'cell'"
      >
        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td key="username" :props="props">{{ props.row.username }}</q-td>
            <q-td key="lastFomoLogin" :props="props">
              <span>{{ formatDate(props.row.lastFomoLogin) }}</span>
            </q-td>
            <q-td key="accountCreationDate" :props="props">
              <span>{{ formatDate(props.row.accountCreationDate) }}</span>
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
  </div>
</template>

<script>
import { useRoute } from "vue-router";
import moment from "moment";
import { ref, computed, onMounted } from "vue";
import statsService from "../../services/stats.service";
import store from "../../store";
export default {
  name: "FomoStats",

  setup() {
    const route = useRoute();
    const searchTerm = ref("");

    onMounted(() => {
      statsService.getFomoUsersTableStats(null);
    });

    const tableData = computed({
      get: () => store.state.fomoStats.fomoUsersTableStats
    });
    const columns = [
      {
        name: "username",
        field: "username",
        label: "Username",
        align: "left",
        sortable: true
      },
      {
        name: "lastFomoLogin",
        field: "lastFomoLogin",
        label: "Last FOMO login",
        align: "left",
        sortable: true
      },

      {
        name: "accountCreationDate",
        field: "accountCreationDate",
        label: "Account creation date",
        align: "left",
        sortable: true
      }
    ];

    const formatDate = stringDate => {
      return moment(stringDate).format("DD-MM-YYYY");
    };

    const searchByTerm = async () => {
      await statsService.getFomoUsersTableStats(searchTerm.value);
    };

    return {
      pagination: {
        rowsPerPage: 500,
        page: 1
      },
      columns,
      searchByTerm,
      route,
      searchTerm,
      tableData,
      formatDate
    };
  },

  methods: {
    isUnderlined(buttonRoute) {
      if (this.route.fullPath.includes(buttonRoute))
        return "btn-nav-underlined";
      return "";
    }
  }
};
</script>
